import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { AlertTriangle, ChevronDown } from 'lucide-react';

export const FollowUpMissingBanner = ({ isAdmin, refreshKey }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get('/crm/follow-up-missing').then(setList).catch(() => {}); }, [refreshKey]);
  if (!list.length) return null;

  return (
    <div data-testid="follow-up-missing-banner" className="rounded-xl border border-amber-500/30 bg-amber-500/[0.07] p-3">
      <button onClick={() => setOpen(o => !o)} data-testid="follow-up-missing-toggle" className="w-full flex items-center gap-2 text-left">
        <AlertTriangle size={16} className="text-amber-400 shrink-0" />
        <span className="text-sm text-amber-100 flex-1">
          <b data-testid="follow-up-missing-count">{list.length}</b> lead(s) sin fecha de siguiente seguimiento
        </span>
        <ChevronDown size={14} className={`text-amber-300 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="mt-3 max-h-72 overflow-y-auto divide-y divide-white/5">
          {list.map(l => (
            <button key={l.id} onClick={() => navigate(`/crm/${l.id}`)} data-testid={`follow-up-missing-${l.id}`}
              className="w-full flex items-center justify-between gap-3 py-2 px-1 text-left hover:bg-white/[0.03] rounded">
              <span className="text-sm text-white truncate">{l.full_name}</span>
              {isAdmin && <span className="text-xs text-[#A38560] shrink-0">{l.assigned_broker_name || 'Sin broker'}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
